import React, {Component, useState, useEffect} from 'react';
import { LineBreak, SubscribePost } from '../../../controller/index'
import axios from 'axios';
import { Shimmer } from 'react-shimmer';

const divStyle = {
  background: `white`,
  border: `1px solid #ccc`,
  padding: 15
}

export default class Content extends Component {

  render(){
    return (
  	<>
    	<section className="contacts-section2">

        <div className="contacts-container01">
          <span className="contacts-text">Privacy</span>
          <h2 className="contacts-text01 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.privacy_policy.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            { this.props.storeData !== null ? LineBreak(this.props.storeData.privacy_policy.split('|')[1]) : <Shimmer width={20} height={4} /> }
          </span>
        </div>

        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.pengumpulan_informasi_pribadi.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left w-100 pl-3">
          <ul>
            {this.props.storeData !== null ? (
              this.props.storeData.pengumpulan_informasi_pribadi.split('|')[1].split(',,').map((item, index) => (
                <li
                  key={index}
                  className=""
                  style={{ textDecoration: 'none', listStyle: 'decimal', textAlign: 'left' }}
                >
                  {item.trim()}
                </li>
              ))
            ) : (
              <Shimmer width={20} height={4} />
            )}
          </ul>
          </span>
        </div>
        
        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.penggunaan_informasi_pribadi.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            {this.props.storeData !== null ? (
              <div dangerouslySetInnerHTML={{ __html: this.props.storeData.penggunaan_informasi_pribadi.split('|')[1] }} />
            ) : (
              <Shimmer width={20} height={4} />
            )}          
          </span>
        </div>

        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.pengungkapan_informasi_pribadi.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            {this.props.storeData !== null ? (
              <div dangerouslySetInnerHTML={{ __html: this.props.storeData.pengungkapan_informasi_pribadi.split('|')[1] }} />
            ) : (
              <Shimmer width={20} height={4} />
            )}          
          </span>
        </div>

        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.penyimpanan_informasi_pribadi.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            {this.props.storeData !== null ? (
              <div dangerouslySetInnerHTML={{ __html: this.props.storeData.penyimpanan_informasi_pribadi.split('|')[1] }} />
            ) : (
              <Shimmer width={20} height={4} />
            )}          
          </span>
        </div>

        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.penghapusan_informasi_pribadi.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            {this.props.storeData !== null ? (
              <div dangerouslySetInnerHTML={{ __html: this.props.storeData.penghapusan_informasi_pribadi.split('|')[1] }} />
            ) : (
              <Shimmer width={20} height={4} />
            )}  
          </span>
        </div>

        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.hak_anda.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            {this.props.storeData !== null ? (
              <div dangerouslySetInnerHTML={{ __html: this.props.storeData.hak_anda.split('|')[1] }} />
            ) : (
              <Shimmer width={20} height={4} />
            )}  
          </span>
        </div>

        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.kebijakan_cookies.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            {this.props.storeData !== null ? (
              <div dangerouslySetInnerHTML={{ __html: this.props.storeData.kebijakan_cookies.split('|')[1] }} />
            ) : (
              <Shimmer width={20} height={4} />
            )}  
          </span>
        </div>

        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.pengakuan_persetujuan.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            {this.props.storeData !== null ? (
              <div dangerouslySetInnerHTML={{ __html: this.props.storeData.pengakuan_persetujuan.split('|')[1] }} />
            ) : (
              <Shimmer width={20} height={4} />
            )}  
          </span>
        </div>

        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.keamanan_data_pribadi.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            {this.props.storeData !== null ? (
              <div dangerouslySetInnerHTML={{ __html: this.props.storeData.keamanan_data_pribadi.split('|')[1] }} />
            ) : (
              <Shimmer width={20} height={4} />
            )}  
          </span>
        </div>

        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.perubahan_kebijakan_privasi.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            {this.props.storeData !== null ? (
              <div dangerouslySetInnerHTML={{ __html: this.props.storeData.perubahan_kebijakan_privasi.split('|')[1] }} />
            ) : (
              <Shimmer width={20} height={4} />
            )}  
          </span>
        </div>

        <div className="contacts-container01">
          <h2 className="contacts-text05 fw-bold">{ this.props.storeData !== null ?  this.props.storeData.hubungi_kami.split('|')[0] : <Shimmer width={20} height={4} /> }</h2>
          <span className="contacts-text02 text-left">
            {this.props.storeData !== null ? (
              <div dangerouslySetInnerHTML={{ __html: this.props.storeData.hubungi_kami.split('|')[1] }} />
            ) : (
              <Shimmer width={20} height={4} />
            )}  
          </span>
        </div>

      </section>

  	</>
      )
  }
}
